import { ImportProvider } from "@redotech/redo-model/customer-import";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const startCustomerImport = {
  name: "startCustomerImport" as const,
  input: z.object({
    teamId: z.string(),
    imports: z.array(
      z.object({
        provider: createEnum(ImportProvider),
        segmentName: z.string(),
        checkUnsubscribed: z.boolean(),
      }),
    ),
  }),
  output: z.object({
    orchestratorWorkflowId: z.string(),
    queuedImports: z.array(
      z.object({ importId: z.string(), segmentName: z.string() }),
    ),
  }),
  files: true,
};
